import { decorate, observable, action, computed } from "mobx";
import ModalHandler from "./ModalHandler";
import BaseStore from "Core/Stores/BaseStore";
import ErrorDetailHandler from "./ErrorDetailHandler";
import ErrorParser from "../../ErrorParser";

export default class ModalsStore extends BaseStore {
  constructor(rootStore) {
    super(rootStore);

    this.handlers = [];
  }

  openModal(modalHandler) {
    if (!modalHandler instanceof ModalHandler) {
      throw new Error("Dialog to open should inherit ModalHandler");
    }
    modalHandler.rootStore = this.rootStore;

    if (modalHandler.fetch) {
      modalHandler.fetch();
    }

    this.handlers.push(modalHandler);
  }

  showErrorDetail(error) {
    if (error) {
      const handler = new ErrorDetailHandler(error);
      const parsedError = new ErrorParser(error, this.rootStore);
      handler.title = parsedError.message;
      this.openModal(handler);
    }
  }

  closeCurrentModal() {
    this.handlers.pop();
  }

  map(fn) {
    return this.handlers.map(fn);
  }

  get hasOpenModals() {
    return this.handlers.length > 0;
  }
}

decorate(ModalsStore, {
  handlers: observable,
  hasOpenModals: computed,
  openModal: action,
  closeCurrentModal: action
});



// WEBPACK FOOTER //
// ./src/Core/Stores/ModalsStore/index.js